import { render, staticRenderFns } from "./PopupDrugInfoView.vue?vue&type=template&id=5e01b9fe&"
import script from "./PopupDrugInfoView.vue?vue&type=script&lang=js&"
export * from "./PopupDrugInfoView.vue?vue&type=script&lang=js&"
import style0 from "./PopupDrugInfoView.vue?vue&type=style&index=0&id=5e01b9fe&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-user-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e01b9fe')) {
      api.createRecord('5e01b9fe', component.options)
    } else {
      api.reload('5e01b9fe', component.options)
    }
    module.hot.accept("./PopupDrugInfoView.vue?vue&type=template&id=5e01b9fe&", function () {
      api.rerender('5e01b9fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/dashboard/popup/PopupDrugInfoView.vue"
export default component.exports